// import all the custom js files here

// Scripts with conditionally called functions (and NOT to be imported dynamically/conditionally)
import './js/bracelets-overview';
import './js/mobile-shop';
import './js/brand-ambassador';
import './js/free-bracelet';
import './js/product-bracelet-pwyw';

// Scripts with IIF
import themeScript from './js/theme';
import footerNewsletterScript from './js/footer-newsletter';
import headerScript from './js/header';

themeScript();
footerNewsletterScript();
headerScript();

// Scripts that should be dynamically loaded (based on `shouldImport` condition)
const bodyClassList = document.body.classList;
const conditionalImports = [
  {
    shouldImport: document.querySelector('.partnerships-logo__container'),
    loader: () => import('./js/partnership-logos'),
  },
  {
    shouldImport: document.querySelector('.partnerships-donations__wrapper'),
    loader: () => import('./js/partnerships-donations'),
  },
  {
    shouldImport: document.querySelector('.animal-missions__wrapper'),
    loader: () => import('./js/animal-carousel'),
  },
  {
    shouldImport:
      bodyClassList.contains('template-product-default') || bodyClassList.contains('template-product-plush'),
    loader: () => import('./js/product-default-carousel'),
  },
  {
    shouldImport:
      bodyClassList.contains('template-product-common-old-v1') ||
      bodyClassList.contains('template-product-plush-old-v1'),
    loader: () => import('./js/product-common-carousel'),
  },
  {
    shouldImport:
      bodyClassList.contains('template-product-bracelets-old-v1') ||
      document.querySelector('.product-bracelets-old-v1') ||
      bodyClassList.contains('template-product-bracelets-pwyw'),
    loader: () => import('./js/product-bracelets-carousel'),
  },
  {
    shouldImport: document.querySelector('.pbo__main-viewport'),
    loader: () => import('./js/product-bracelet-overview'),
  },
  {
    shouldImport: document.querySelector('.pco__main-viewport'),
    loader: () => import('./js/product-common-overview'),
  },
  {
    shouldImport: bodyClassList.contains('template-product-bracelets-multi-species'),
    loader: () => import('./js/product-bracelets-multi-carousel'),
  },
  {
    shouldImport: bodyClassList.contains('page-type-collection'),
    loader: () => import('./js/collection-filter'),
  },
  {
    shouldImport: document.querySelector('.home-hero'),
    loader: () => import('./js/home-hero-slider'),
  },
  {
    shouldImport: document.querySelector('.featured-carousel__container'),
    loader: () => import('./js/featured-carousel'),
  },
  {
    shouldImport: document.querySelector('.featured-collection-carousel'),
    loader: () => import('./js/featured-collection-carousel'),
  },
  {
    shouldImport: document.querySelector('.accordion'),
    loader: () => import('./js/accordion'),
  },
  {
    shouldImport: document.querySelector('.product-faq__accordion-columns'),
    loader: () => import('./js/column-accordion'),
  },
  {
    shouldImport: document.querySelector('.collection-buttons__wrapper'),
    loader: () => import('./js/collections-buttons'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-wholesale-program-2'),
    loader: () => import('./js/wholesale-page'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-wholesale-program-2'),
    loader: () => import('./js/wholesale-page-form'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/partner-page'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/partner-page-form'),
  },
  {
    shouldImport: bodyClassList.contains('template-page-partner-program'),
    loader: () => import('./js/testimonials'),
  },
  {
    shouldImport: document.querySelector('.accordion-content__wrapper ul li'),
    loader: () => import('./js/accordion-list-item-layout'),
  },
  {
    shouldImport: document.querySelector('.product-social-videos'),
    loader: () => import('./js/product-social-videos'),
  },
  {
    shouldImport: document.querySelector('.product-exploration'),
    loader: () => import('./js/product-exploration'),
  },
  {
    shouldImport: document.querySelector('.conservation-small-module'),
    loader: () => import('./js/conservation-module'),
  },
  {
    shouldImport: document.querySelector('.product-bracelets'),
    loader: () => import('./js/kaching-bundle'),
  },
  {
    shouldImport: document.querySelector('.hero-animal-tracker'),
    loader: () => import('./js/hero-animal-tracker'),
  },
  {
    shouldImport: document.querySelector('.species-spotlight'),
    loader: () => import('./js/species-spotlight'),
  },
  {
    // Cross-fade (`__promo`) or ticker (`__track`) — the static single-promo bar has neither.
    shouldImport: document.querySelector('.announcement-bar__promo, .announcement-bar__track'),
    loader: () => import('./js/announcement-bar'),
  },
  {
    shouldImport: document.querySelector('.app-demo'),
    loader: () => import('./js/app-demo'),
  },
  {
    shouldImport: document.querySelector('.interactive-species-map'),
    loader: () => import('./js/interactive-map'),
  },
  {
    // The panel is only rendered while the end date is still in the future, so a page loaded after
    // the countdown has passed already has the post-countdown CTA from Liquid and needs no JS.
    shouldImport: document.querySelector('[data-promotional-countdown]'),
    loader: () => import('./js/promotional-countdown'),
  },
];

conditionalImports.forEach(({ shouldImport, loader }) => {
  if (shouldImport) {
    loader()
      .then((module) => {
        module.default();
      })
      .catch((err) => {
        console.error(`Error executing ${loader}`, err);
      });
  }
});

// Theme editor: a section added to a page that had no instance at initial load
// never matches the shouldImport hooks above, so import when its markup appears.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.hero-animal-tracker')) {
      import('./js/hero-animal-tracker')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing hero-animal-tracker loader', err);
        });
    }
    if (event.target.querySelector('.species-spotlight')) {
      import('./js/species-spotlight')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing species-spotlight loader', err);
        });
    }
    if (event.target.querySelector('.app-demo')) {
      import('./js/app-demo')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing app-demo loader', err);
        });
    }
    if (event.target.querySelector('.announcement-bar__promo, .announcement-bar__track')) {
      import('./js/announcement-bar')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing announcement-bar loader', err);
        });
    }
    if (event.target.querySelector('.interactive-species-map')) {
      import('./js/interactive-map')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing interactive-species-map loader', err);
        });
    }
    if (event.target.querySelector('[data-promotional-countdown]')) {
      import('./js/promotional-countdown')
        .then((module) => {
          module.default();
        })
        .catch((err) => {
          console.error('Error executing promotional-countdown loader', err);
        });
    }
  });
}
